<template>
  <fragment
    v-bind:title="title"
    v-on:remove="$emit('remove')"
  >
    <label class="fragment-date">
      <input
        class="fragment-date__input"
        type="date"
        v-model="value" />
    </label>
  </fragment>
</template>
<script>
import Fragment from '@/components/NotificationPlan/Fragment.vue';

/**
 * @description Фрагмент вводимой даты формы создания шаблона СМС.
 * @type {Vue}
 */
export default {
  components: {
    Fragment,
  },
  data() {
    return {
      value: '',
    };
  },
  name: 'NotificationPlanDate',
  props: {
    ...Fragment.props,
  },
  watch: {
    value() {
      this.$emit('input', this.value);
    },
  },
};
</script>
<style lang="scss" scoped>
.fragment-date {
  &__input {
    border: 1px solid var(--border-color);
    border-radius: var(--input-border-radius);
    padding: .3rem .625rem;
  }
}
</style>
